import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { RouteContentProtection } from '../UI.shared/RouteContentProtection';

const ProfilePage = lazy(() => import('./Profile.page/Profile.layout'));
const SupportSection = lazy(() => import('./Support.section'));
const SurveysSection = lazy(() => import('./Surveys.section/Surveys.layout'));
const TrendsSection = lazy(() => import('./Trends.section/Trends.layout'));
const ConversationsSection = lazy(() => import('./Conversations.section/Conversations.layout'));
const ActionPlanningSection = lazy(() => import('./ActionPlanning.section/ActionPlanning.layout'));
const UsersSection = lazy(() => import('./Users.section/Users.section'));
const EmployeesSection = lazy(() => import('./Employees.section/Employees.section'));
const MailingListSection = lazy(() => import('./MailingLists.section/MailingList.layout'));
const LearningCoachSection = lazy(() => import('./LearningCoach.section/LearningCoach.layout'));
const SettingsSection = lazy(() => import('./Settings.section/Settings.layout'));
const HelpPage = lazy(() => import('./Help.page'));
const CustomRoleSection = lazy(() => import('./KW.section/customRole'));
const AdminSection = lazy(() => import('./Admin.section/Admin.routes'));
const OpenSection = lazy(() => import('../Open.section/Open.layout'));

const MainRoutes = () => (
  <Routes>
    <Route
      path="/profile"
      element={
        <RouteContentProtection>
          <ProfilePage />
        </RouteContentProtection>
      }
    />
    <Route
      path="/surveys/*"
      element={
        <RouteContentProtection>
          <SurveysSection />
        </RouteContentProtection>
      }
    />
    <Route
      path="/trends/*"
      element={
        <RouteContentProtection>
          <TrendsSection />
        </RouteContentProtection>
      }
    />
    <Route
      path="/conversations/*"
      element={
        <RouteContentProtection>
          <ConversationsSection />
        </RouteContentProtection>
      }
    />
    <Route
      path="/action-planning/*"
      element={
        <RouteContentProtection>
          <ActionPlanningSection />
        </RouteContentProtection>
      }
    />
    <Route
      path="/users/*"
      element={
        <RouteContentProtection>
          <UsersSection />
        </RouteContentProtection>
      }
    />
    <Route
      path="/employees/*"
      element={
        <RouteContentProtection>
          <EmployeesSection />
        </RouteContentProtection>
      }
    />
    <Route
      path="/mailing-lists/*"
      element={
        <RouteContentProtection>
          <MailingListSection />
        </RouteContentProtection>
      }
    />
    <Route
      path="/learning-coach/*"
      element={
        <RouteContentProtection>
          <LearningCoachSection />
        </RouteContentProtection>
      }
    />
    <Route
      path="/settings/*"
      element={
        <RouteContentProtection>
          <SettingsSection />
        </RouteContentProtection>
      }
    />
    <Route
      path="/help"
      element={
        <RouteContentProtection>
          <HelpPage />
        </RouteContentProtection>
      }
    />
    <Route
      path="/kazoo"
      element={
        <RouteContentProtection>
          <CustomRoleSection />
        </RouteContentProtection>
      }
    />
    <Route
      path="/admin/*"
      element={
        <RouteContentProtection>
          <AdminSection />
        </RouteContentProtection>
      }
    />
    <Route
      path="/support/*"
      element={
        <RouteContentProtection>
          <SupportSection />
        </RouteContentProtection>
      }
    />
    <Route
      path="*"
      element={
        <RouteContentProtection>
          <OpenSection />
        </RouteContentProtection>
      }
    />
  </Routes>
);

export default MainRoutes;
